// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;
  height: 100vh;
}

#dark .message_sources{
  color :rgba(33, 14, 58, 0.63);
}
.message_sources{
  color : #1b1b1a;
  font-weight: normal;
  text-decoration: none;
}
.chat-box {
  width: 500px;
}

#dark .scrollbar-container {
  background-color: #242530; 

  /* background-color: #141f31; */
    background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412)); 

}

#light .scrollbar-container {
  background-color: #dad8d8;
}

#dark .cs-message__content {
  background-color: #373e4e;
  color: white;
}

#light .cs-message__content {
  background-color: white;
  color: black;
  font-size: 16px;


}
.cs-message__content{
  border-radius: 0 0.7em 0.7em 0.7em;

}
.cs-message--outgoing .cs-message__content {
  border-radius:  0.7em 0.0 0.7em 0.7em;
}

#dark .cs-message--outgoing .cs-message__content {
  background-color: #743f84;
  color: white;
}

#light .cs-message--outgoing .cs-message__content {
  background-color: #a8d7f1;
  color: black;
  
}

#dark .cs-message-input__content-editor-wrapper {
  background-color: #3d4354;
}

#light .cs-message-input__content-editor-wrapper {
  background-color: white;
}

.cs-message-input__content-editor[data-placeholder]:empty:before {
  text-align: start;
}

#dark .cs-message-input__content-editor[data-placeholder]:empty:before {
  background-color: #3d4354;
  color: rgba(255, 255, 255, 0.418);
}

#light .cs-message-input__content-editor[data-placeholder]:empty:before {
  background-color: white;
  color: rgba(0, 0, 0, 0.418);
}
.cs-message-input__content-editor[data-placeholder] {
  text-align: start;
}

#dark .cs-message-input__content-editor[data-placeholder] {
  background-color: #3d4354;
  color: white;
}

#light .cs-message-input__content-editor[data-placeholder] {
  background-color: white;
  color: #444343;
}

.cs-chat-container .cs-message-input {
  padding-bottom: 10px;
}

#dark .cs-chat-container .cs-message-input {
  background: transparent;
}

#light .cs-chat-container .cs-message-input {
  background-color: #dad8d8;
}

.cs-chat-container .cs-message-input {
  margin: 0;
}

#dark .cs-message-input__tools:first-child .cs-button:last-child {
  color: #7a8194;
}

#light .cs-message-input__tools:first-child .cs-button:last-child {
  color: #212224;
}

#dark .cs-message-input__tools:last-child .cs-button:last-child {
  color: #7a8194;
}

#light .cs-message-input__tools:last-child .cs-button:last-child {
  color: #212224;
}

.cs-main-container {
  border: 0;
  border-radius: 0px;
  background: transparent;
  height: calc(100vh - 32px);
}
.cs-chat-container{
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.cs-chat-container .cs-message-input{
  border-top: 0;
}

.cs-message-input {
  display: flex !important;
  align-items: flex-end !important;
  flex-direction: row !important;
  box-sizing: border-box;
}
.time {
  color: white;
  text-align: center;
}

.timecoach {
  margin: 0;
  font-size: 12px;
}

.timeuser {
  text-align: end;
  margin: 0;
  font-size: 12px;
}

#dark .timecoach {
  color: rgb(149, 149, 149);
}

#dark .timeuser {
  color: rgb(149, 149, 149);
}

#light .timecoach {
  color: #403939;
}

#light .timeuser {
  color: #403939;
}

.cs-message-list {
  background-color: #dad8d8;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: inherit;
}

.cs-message-list__scroll-wrapper {
  height: auto;
}

@media screen and (max-width: 768px){
  .chat-box {
    width: 400px;
  }
  .cs-main-container {
    height: 90vh;
  }
}

@media screen and (max-width: 420px){
  .chat-box {
    width: 300px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Chatbox/Chatbox.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;;EAEzB,+BAA+B;IAC7B,mEAAmE;;AAEvE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;;;AAGjB;AACA;EACE,kCAAkC;;AAEpC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;;AAEd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  font-weight: bold;\n  height: 100vh;\n}\n\n#dark .message_sources{\n  color :rgba(33, 14, 58, 0.63);\n}\n.message_sources{\n  color : #1b1b1a;\n  font-weight: normal;\n  text-decoration: none;\n}\n.chat-box {\n  width: 500px;\n}\n\n#dark .scrollbar-container {\n  background-color: #242530; \n\n  /* background-color: #141f31; */\n    background-image: linear-gradient(#141f31, rgba(23, 10, 40, 0.412)); \n\n}\n\n#light .scrollbar-container {\n  background-color: #dad8d8;\n}\n\n#dark .cs-message__content {\n  background-color: #373e4e;\n  color: white;\n}\n\n#light .cs-message__content {\n  background-color: white;\n  color: black;\n  font-size: 16px;\n\n\n}\n.cs-message__content{\n  border-radius: 0 0.7em 0.7em 0.7em;\n\n}\n.cs-message--outgoing .cs-message__content {\n  border-radius:  0.7em 0.0 0.7em 0.7em;\n}\n\n#dark .cs-message--outgoing .cs-message__content {\n  background-color: #743f84;\n  color: white;\n}\n\n#light .cs-message--outgoing .cs-message__content {\n  background-color: #a8d7f1;\n  color: black;\n  \n}\n\n#dark .cs-message-input__content-editor-wrapper {\n  background-color: #3d4354;\n}\n\n#light .cs-message-input__content-editor-wrapper {\n  background-color: white;\n}\n\n.cs-message-input__content-editor[data-placeholder]:empty:before {\n  text-align: start;\n}\n\n#dark .cs-message-input__content-editor[data-placeholder]:empty:before {\n  background-color: #3d4354;\n  color: rgba(255, 255, 255, 0.418);\n}\n\n#light .cs-message-input__content-editor[data-placeholder]:empty:before {\n  background-color: white;\n  color: rgba(0, 0, 0, 0.418);\n}\n.cs-message-input__content-editor[data-placeholder] {\n  text-align: start;\n}\n\n#dark .cs-message-input__content-editor[data-placeholder] {\n  background-color: #3d4354;\n  color: white;\n}\n\n#light .cs-message-input__content-editor[data-placeholder] {\n  background-color: white;\n  color: #444343;\n}\n\n.cs-chat-container .cs-message-input {\n  padding-bottom: 10px;\n}\n\n#dark .cs-chat-container .cs-message-input {\n  background: transparent;\n}\n\n#light .cs-chat-container .cs-message-input {\n  background-color: #dad8d8;\n}\n\n.cs-chat-container .cs-message-input {\n  margin: 0;\n}\n\n#dark .cs-message-input__tools:first-child .cs-button:last-child {\n  color: #7a8194;\n}\n\n#light .cs-message-input__tools:first-child .cs-button:last-child {\n  color: #212224;\n}\n\n#dark .cs-message-input__tools:last-child .cs-button:last-child {\n  color: #7a8194;\n}\n\n#light .cs-message-input__tools:last-child .cs-button:last-child {\n  color: #212224;\n}\n\n.cs-main-container {\n  border: 0;\n  border-radius: 0px;\n  background: transparent;\n  height: calc(100vh - 32px);\n}\n.cs-chat-container{\n  background: transparent;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n.cs-chat-container .cs-message-input{\n  border-top: 0;\n}\n\n.cs-message-input {\n  display: flex !important;\n  align-items: flex-end !important;\n  flex-direction: row !important;\n  box-sizing: border-box;\n}\n.time {\n  color: white;\n  text-align: center;\n}\n\n.timecoach {\n  margin: 0;\n  font-size: 12px;\n}\n\n.timeuser {\n  text-align: end;\n  margin: 0;\n  font-size: 12px;\n}\n\n#dark .timecoach {\n  color: rgb(149, 149, 149);\n}\n\n#dark .timeuser {\n  color: rgb(149, 149, 149);\n}\n\n#light .timecoach {\n  color: #403939;\n}\n\n#light .timeuser {\n  color: #403939;\n}\n\n.cs-message-list {\n  background-color: #dad8d8;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  height: inherit;\n}\n\n.cs-message-list__scroll-wrapper {\n  height: auto;\n}\n\n@media screen and (max-width: 768px){\n  .chat-box {\n    width: 400px;\n  }\n  .cs-main-container {\n    height: 90vh;\n  }\n}\n\n@media screen and (max-width: 420px){\n  .chat-box {\n    width: 300px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
